import { FormRow } from 'framework/ui/layout';
import { TextInput, PhoneInput, DefaultInputPropTypes, useInputHelper } from 'framework/form';

const ContactVendorsInputs = ({ ...props }: DefaultInputPropTypes<any>) => {
  const { getSource } = useInputHelper(props);
  const source = getSource();
  return (
    <FormRow colXl={4}>
      <TextInput label="" placeholder="Name" source={`${source}.name`} />
      <PhoneInput label="" placeholder="Phone" source={`${source}.phoneNumber`} />
      <TextInput label="" placeholder="Email" source={`${source}.email`} />
    </FormRow>
  );
};

export default ContactVendorsInputs;
